/**
 * ч.1442: спосіб підпису в системі — ключі КЕП сесії, хмарний ключ / токен (віджет ІІТ) і, якщо
 * підключено, Дія.Підпис (віджет id.gov.ua). Один вигляд у журналі ЕДО і в підтвердженні учасника.
 */
import WidgetSign from './WidgetSign';
import { DIIA_TEST_NOTE, useSignWidgets } from './useSignWidgets';

export type SignMethod = 'session' | 'widget' | 'diia';

export function SignMethodTabs({ value, onChange, sessionLabel = 'ключі КЕП сесії' }: {
  value: SignMethod;
  onChange: (m: SignMethod) => void;
  sessionLabel?: string;
}) {
  const widgets = useSignWidgets();
  const opts: [SignMethod, string][] = [
    ['session', sessionLabel],
    ['widget', 'хмарний ключ / токен'],
    ...(widgets?.diia ? [['diia', 'Дія.Підпис'] as [SignMethod, string]] : []),
  ];
  return (
    <div className="seg-tabs" role="tablist" aria-label="Спосіб підпису" style={{ marginTop: 0 }}>
      {opts.map(([m, label]) => (
        <button key={m} type="button" role="tab" aria-selected={value === m}
          className={value === m ? 'active' : ''} onClick={() => onChange(m)}>{label}</button>
      ))}
    </div>
  );
}

/** Віджет обраного способу: ІІТ («хмарний ключ / токен») або id.gov.ua (Дія.Підпис). */
export function MethodWidget({ method, getData, onSigned }: {
  method: 'widget' | 'diia';
  getData: () => Promise<Uint8Array>;
  onSigned: (signatureB64: string) => Promise<void>;
}) {
  const diia = useSignWidgets()?.diia ?? null;
  if (method === 'diia' && diia) {
    return (
      <div key="diia">
        {diia.test_env && (
          <p role="note" style={{
            background: 'var(--badge-amber-bg)', color: 'var(--badge-amber-fg)', border: '1px solid var(--badge-amber-bd)',
            borderRadius: 'var(--radius)', padding: '0.45rem 0.65rem', fontSize: '0.8rem', margin: '0 0 0.5rem',
          }}>{DIIA_TEST_NOTE}</p>
        )}
        <WidgetSign widgetUri={diia.sign_url} loaderSrc={diia.loader}
          providerLabel="Дія.Підпис, файл, токен або хмарний ключ" getData={getData} onSigned={onSigned} />
      </div>
    );
  }
  return <WidgetSign key="iit" getData={getData} onSigned={onSigned} />;
}
